import React from 'react'
import ReactDOM from 'react-dom/client'
// import { Provider } from 'react-redux'
import 'flatpickr/dist/flatpickr.min.css'

// import { store } from 'redux/store/index'
import { BrowserRouter } from 'react-router-dom'
import { ChakraProvider, extendTheme } from '@chakra-ui/react'
import { Provider } from 'react-redux'
import store from 'redux/store/index'
import App from './App'
import reportWebVitals from './reportWebVitals'
// 2. Extend the theme to include custom colors, fonts, etc
const colors = {
  brand: {
    50: '#F3F5F9',
    100: '#E5EEFC',
    900: '#020202',
  },
}
const direction = 'ltr'

const theme = extendTheme({
  colors,
  direction,
  fonts: {
    heading: `'Poppins', 'Open Sans', sans-serif`,
    body: `'Poppins','Raleway', sans-serif`,
  },
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <ChakraProvider theme={theme}>
          <App />
        </ChakraProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
